import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import "aos/dist/aos.css";
import './styles.css';
import MapboxGLMap from './mapbox';

import Windfarms from '../../assets/data/Eolica - Track Record.json';


function Onshore() {
  useEffect(() => {
    AOS.init()
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])

  const [windfarms_data, setWindfarmsData] = useState(Windfarms.filter(windfarm => windfarm.Technology === 'WIND'));
  const [filter, setFilter] = useState('All');
  const filterWindfarms = (filtered: string) => {
    if (filter === filtered) {
      setFilter('All');
      setWindfarmsData(Windfarms.filter(windfarm => windfarm.Technology === 'WIND'));
    } else {
      setFilter(filtered);
      setWindfarmsData(Windfarms.filter(windfarm => {
        return windfarm.Status === filtered && windfarm.Technology === 'WIND'
      }))
    }
  }
  return (
    <div>
      <Header />
      <div className="content-onshore" data-aos="fade-in" data-aos-delay="100" data-aos-duration="1500">
        <div className="windfarm-list">
          <div className="filter-list">
            <div className="filter-item" onClick={() => filterWindfarms('Operating')}>Operating</div>
            <div className="filter-item" onClick={() => filterWindfarms('Under Construction')}>Under construction</div>
            <div className="filter-item" onClick={() => filterWindfarms('Sold')}> Sold to third parties</div>
          </div>
          <hr />
          <div className="list-title">
            <h1>Wind farms</h1>
            <p>Total Wind farms: &nbsp;{windfarms_data.length}</p>
            <small>Showing: <b>{filter}</b></small>
          </div>
          <hr />
          {
            windfarms_data.map((windfarm, index) => (
              <div key={index} className="windfarms" >
                <div>
                  <h1>{windfarm.Project}</h1>
                  <h2>{windfarm.State}</h2>
                  <h2>Total Capacity: {windfarm.MW}</h2>
                </div>
                {windfarm.Status === 'Operating' ? <Link to={{ pathname: windfarm.Path}}> View</Link> : null}
              </div>
            ))
          }
        </div>
        <div className="mapbox-container">
          <MapboxGLMap windfarms={windfarms_data} key={windfarms_data} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Onshore;